/* eslint react-hooks/exhaustive-deps: 0 */
import React from 'react';
// TODO: what if f changes?
export const useUpdateEffect = (f, dependencies) => {
    const [stateUpdated, setUpdated] = React.useState(false);
    React.useEffect(() => {
        if (stateUpdated) {
            f();
        }
        else {
            setUpdated(true);
        }
    }, dependencies);
};
export default useUpdateEffect;
